module.exports = __webpack_public_path__ + "static/img/drawBtn.759978d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drawBtn.png
// module id = M2Ng
// module chunks = 1